import React from 'react';

const ContatoContent = () => (
  <p>
    Contato Content
  </p>
);

export default ContatoContent;